import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class UnsettledDocumentItem {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  netValue!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @IsOptional()
  @Expose()
  costDocumentNumbers!: string;
  @IsNumber()
  @IsOptional()
  @Expose()
  purchasePrice!: number | null;
  @IsString()
  @IsOptional()
  @Expose()
  purchaseCurrency!: string;
}
